import store from "@/store";

export default [
  {
    name: "Stocks",
    path: "/stocks",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/equipmentWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "StocksProfile",
    path: "/stocks/profile/:id",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/equipmentWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "Stocks/Categories",
    path: "/stocks/categories",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/equipmentWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  },
  {
    name: "Stocks/Units",
    path: "/stocks/units",
    beforeEnter: (_to, _from, next) => {
      if (store.getters["auth/equipmentWrite"]) {
        next();
        return;
      } else next({ path: "/error" });
    }
  }
];
